(function () {
  const STYLE_ID = 'amorfit-forms-teaser-style';
  const INITIAL_CHECK_DELAY = 300;
  const RETRY_INTERVAL = 500;

  const observedShadows = new WeakSet();

  function addStyles(shadow) {
    if (shadow.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;

    style.textContent = `
      button[data-testid="form-teaser"] {
       width: 70px !important;
height: 70px !important;
min-width: 70px !important;
min-height: 70px !important;
padding: 0 !important;
margin: 0 !important;
border-radius: 0 !important;
background: transparent !important;
border: none !important;
box-shadow: none !important;
position: relative !important;
display: block !important;
overflow: visible !important;
cursor: pointer !important;
      }

      button[data-testid="form-teaser"] h3 {
        display: none !important;
      }

      button[data-testid="form-teaser"] .gift-icon {
        position: absolute !important;
        left: 50% !important;
        top: 50% !important;
width: 70px !important;
height: 70px !important;
        transform: translate(-50%, -50%) !important;
        display: block !important;
        margin: 0 !important;
        pointer-events: none !important;
      }

      button[data-testid="form-teaser"] .gift-badge {
        position: absolute !important;
        top: -4px !important;
        right: -4px !important;
        width: 21px !important;
        height: 21px !important;
        padding: 0 !important;
        margin: 0 !important;
        border-radius: 50% !important;
        background: #e91e63 !important;
        color: #fff !important;
        font: 700 12px/21px Arial, sans-serif !important;
        text-align: center !important;
        z-index: 20 !important;
        pointer-events: none !important;
      }

      button[data-testid="form-teaser"] [aria-label="Close modal"] {
        position: absolute !important;
        left: -3px !important;
        top: -3px !important;
        width: 19px !important;
        height: 19px !important;
        min-width: 19px !important;
        min-height: 19px !important;
        padding: 0 !important;
        margin: 0 !important;
        border-radius: 50% !important;
        background: #111 !important;
        color: #fff !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        z-index: 30 !important;
      }

      button[data-testid="form-teaser"] [aria-label="Close modal"] svg {
        width: 11px !important;
        height: 11px !important;
        stroke: #fff !important;
      }

      button[data-testid="form-teaser"]:hover {
        transform: scale(1.05) !important;
      }
        @media (max-width: 749px) {
  button[data-testid="form-teaser"] {
 width: 68px !important;
height: 68px !important;
min-width: 68px !important;
min-height: 68px !important;
  transform: translate(8px, -8px) !important;
}
}

  button[data-testid="form-teaser"] .gift-icon {
width: 68px !important;
height: 68px !important;
}
  }

  button[data-testid="form-teaser"] .gift-badge {
  display: none !important;
}
button[data-testid="form-teaser"] [aria-label="Close modal"] {
  display: none !important;
}
button[data-testid="form-teaser"] > *:not(.gift-icon) {
  display: none !important;
}
  button[data-testid="form-teaser"] [aria-label="Close modal"] svg {
    width: 10px !important;
    height: 10px !important;
  }
}
    `;

    shadow.appendChild(style);
  }

  function applyGift(shadow) {
    const button = shadow.querySelector('button[data-testid="form-teaser"]');
if (!button) return;

// Ocultar la notificación nativa de Shopify Forms
shadow.querySelectorAll('*').forEach((el) => {
  if (
    el !== button &&
    el.textContent.trim() === '1' &&
    el.children.length === 0
  ) {
    el.style.display = 'none';

    if (el.parentElement && el.parentElement !== button) {
      el.parentElement.style.display = 'none';
    }
  }
});

let gift = button.querySelector('.gift-icon');

    if (!gift) {
      gift = document.createElementNS(
        'http://www.w3.org/2000/svg',
        'svg'
      );

      gift.setAttribute('class', 'gift-icon');
      gift.setAttribute('viewBox', '0 0 64 64');
      gift.setAttribute('fill', 'none');
      gift.setAttribute('stroke', '#111');
      gift.setAttribute('stroke-width', '3');
      gift.setAttribute('stroke-linecap', 'round');
      gift.setAttribute('stroke-linejoin', 'round');
      gift.setAttribute('aria-hidden', 'true');

gift.innerHTML = `
  <image
    href="${window.AMORFIT_TEASER_GIFT_URL}"
    x="0"
    y="0"
    width="64"
    height="64"
    preserveAspectRatio="xMidYMid meet"
  />
`;
      button.appendChild(gift);
    }

    let badge = button.querySelector('.gift-badge');

    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'gift-badge';
      badge.textContent = '1';
      button.appendChild(badge);
    }
  }

  function setupShadow(shadow) {
    if (!shadow || observedShadows.has(shadow)) return;

    observedShadows.add(shadow);

    addStyles(shadow);

    const apply = () => applyGift(shadow);

    apply();

    const observer = new MutationObserver(() => {
      apply();
    });

    observer.observe(shadow, {
      childList: true,
      subtree: true
    });
  }

  function findFormsShadow() {
    const hosts = document.querySelectorAll(
      'shopify-forms-embed'
    );

    hosts.forEach((host) => {
      if (host.shadowRoot) {
        setupShadow(host.shadowRoot);
      }
    });
  }

  function start() {
    findFormsShadow();

    const documentObserver = new MutationObserver(() => {
      findFormsShadow();
    });

    documentObserver.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    setTimeout(findFormsShadow, INITIAL_CHECK_DELAY);
    setInterval(findFormsShadow, RETRY_INTERVAL);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();